"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.common.help': 'Los avatares comunes son visibles para todos los usuarios pero no pueden ser editados por no super-administradores',
};
